import packageJson from '../../../package'

export default {
    VERSAO: packageJson.version,
    NOME: 'patrimonio-intangivel',
    PARAMETRO_NAMESPACE: 'az.patrimonio-intangivel',
    COPYRIGHT: 'Todos os direitos reservados',
    LOGOUT_URL: '/hal/logout',
    URL_SIGAPATRIMONIO: 'sigapatrimonio'
}
